import React from 'react';

import { type TooltipOptions } from '@pkg/components';
import { TooltipContext, useTooltip } from '@pkg/components/Elements/Tooltip/hooks';

interface TooltipProps extends TooltipOptions {
    children: React.ReactNode;
}
export function TooltipItem({ children, ...options }: TooltipProps) {
    const tooltip = useTooltip(options);
    return <TooltipContext.Provider value={tooltip}>{children}</TooltipContext.Provider>;
}
